import { render, staticRenderFns } from "./store.vue?vue&type=template&id=6a963e99&"
import script from "./store.vue?vue&type=script&lang=js&"
export * from "./store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports